import React, { useEffect, useState } from 'react'
import Sidebar from '../../Common/Sidebar/Sidebar';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import '../globalStyle.css';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import Modal from "react-modal";
import { isMobile } from 'react-device-detect';
import EditKitabName from './EditKitabName';
import { toast } from 'react-toastify';

//customStyles for model
const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: isMobile ? "100%" : '55%',
    },
  };

const FilterComponent = ({ filterText, onFilter, onClear }) => (
<div className="d-flex">
    <input
        id="search"
        className="form-control dataTableSearch"
        type="text"
        placeholder="Filter By Kitab Name"
        aria-label="Search Input"
        value={filterText}
        onChange={onFilter}
    />
    <button className="btn btn-primary" type="button" onClick={onClear}>
        X
    </button>
</div>
);

export default function AllKitabName() {
    const [filterText, setFilterText] = React.useState('');
	const [edit, setEdit] = useState(false);
    const [editKitabNameInfo, setEditKitabNameInfo] = useState({});
    const [kitabNameList, setKitabNameList] = useState([]);
	const [deletePopUP, setDeletePopUP] = useState(false);
    const [deleteId, setDeleteId] = useState();

	const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

    //get all kitab 
    useEffect( ()  => {     
        async function fetchData() {   
         const kitabName = await axios.get(`https://ahlehaqserver.herokuapp.com/api/kitabName`)
         setKitabNameList(kitabName.data.response);
        }
        fetchData(); 
      },[edit])

	  //edit function
	  const handleEdit = (e) => {
        setEditKitabNameInfo(e);
        setEdit(true);
      };

	  //kitab delete function 
	  const deleteConfirmation = (e) => {
		setDeletePopUP(true);
		setDeleteId(e);
	  };
	
	  const deleteKitab = async (e) => {
		try {
		  //
		  axios
			.delete(`https://ahlehaqserver.herokuapp.com/api/kitabName/${e}`)
			.then((res) => console.log(res));
	
		  const filtered = kitabNameList.filter((k) => k._id !== e);
		  setKitabNameList(filtered);
		  toast.success("Kitab Name deleted successfully!");
		  setDeletePopUP(false);
		} catch (error) {
		  console.log(error);
		}
	  };

        //data table related functions
	  const columns = [
		{
			name: 'Kitab Name',
			selector: row => row.kitabName,
			sortable: true,
		},
		{
			name: 'Writer Name',
			selector: row => row.writerName,
			sortable: true,
		},
    {
			name: 'Language',
			selector: row => row.bangla === true ? "Bangla" : "Urdu",
			sortable: true,
		},
    {
			name: 'Pdf',
			selector: row => row.pdf === true ? "Pdf Book" : "Manual",
			sortable: true,
		},
    {
			name: 'Image',
			selector: row => <img src={row.imageUrl} style={{height: "80px", width: "60px"}} alt="" /> ,
			sortable: true,
		},
		{
			cell: (row) => 	<>
				<span
				onClick={() => handleEdit(row)}
				style={{ cursor: "pointer" }}
				>
				{" "}
					<FaEdit />{" "}
				</span>
				<span
				onClick={() => deleteConfirmation(row._id)}
				style={{ cursor: "pointer" }}
				className="ml-2"
				>
			    	<RiDeleteBin6Line />
				</span>
			</>,
			allowOverflow: true,
			button: true,
			width: '56px',
		},
		// <HiOutlineDotsVertical />
	];


	const filteredItems = kitabNameList.filter(
		item => item.kitabName && item.kitabName.toLowerCase().includes(filterText.toLowerCase()),
	);

	const subHeaderComponentMemo = React.useMemo(() => {
		const handleClear = () => {
			if (filterText) {
				setResetPaginationToggle(!resetPaginationToggle);
				setFilterText('');
			}
		};

		return (
			<div className="row">
				<div className="col-md-12 ">
			     	<FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
				</div>
			</div>
		);
	}, [filterText, resetPaginationToggle]);

    return (
        <div>
         <Modal isOpen={edit} style={customStyles}>
            <EditKitabName
              setEdit={setEdit}
              editKitabNameInfo={editKitabNameInfo}
            />
          </Modal>
            <div>
                <div className="row">
                    <div className="col-md-3">
                        <Sidebar/>
                    </div>
                    <div className="col-md-9">
                    <DataTable
                        title="See all kitab Name"
                        columns={columns}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        persistTableHead
                        highlightOnHover
                    />
                    </div>
                </div> 
                </div>
                <Modal isOpen={deletePopUP} style={customStyles}>
                    <div className="p-3">
                    <p className="font-weight-bold text-center">Are you sure?</p>
                    <div className="row justify-content-center">
                        <div className="col-5">
                        <button
                            className="btn btn-danger rounded-pill px-4"
                            onClick={() => deleteKitab(deleteId)}
                        >
                            Yes
                        </button>
                        </div>
                        <div className="col-5 mr-3">
                        <button
                            className="btn btn-success rounded-pill px-3"
                            onClick={() => setDeletePopUP(false)}
                        >
                            Cancel
                        </button>
                        </div>
                    </div>
                    </div>
                </Modal>
            </div>
    )
}
